import defaultTheme from '../defaultTheme'

const theme: typeof defaultTheme = {
  ...defaultTheme,
}

export default theme
